<template>
  <b-modal
    :title="`Recibido de Contraloría para el Expediente ${controlFile.numero}`"
    v-model="showModal"
    no-close-on-backdrop
    centered
    hide-footer
    content-class="fullscreen"
    size="xl"
  >
    <div class="row" id="management">
      <div class="col-8">
        <div v-if="!selectedFile">
          <h4 class="text-primary">
            Por favor carga el archivo recibido de contraloría
            para continuar con su tramitación
          </h4>
        </div>
        <div v-if="selectedFile" class=" d-flex shadow bg-gray">
          <div ref="pdfViewport" class="container-pdf position-relative page">
            <pdf
              class="m-auto"
              v-for="i in numPages"
              :key="i"
              :page="i"
              :src="selectedFile"
            />
            <drag-sign-office
              v-if="sign"
              :position="positionSign"
              process-type="Tramitar"
              ref="sign"
            />
          </div>
        </div>
      </div>
      <div class="col-4">
        <div class="text-right">
          <UploadFile
            permission="*"
            text="Cargar documento"
            v-model="file"
            :upload-to="urlFile"
            button-class=""
            container-class="text-right"
            @input="addFile()"
          />
        </div>
        <form
          data-vv-scope="sign-document"
          class="mt-4"
        >
          <div>
            <div class="mt-3">
              <label>Fecha</label>
              <b-form-datepicker
                :max="max"
                id="example-datepicker"
                v-model="manageDate"
                class="w-100"
                label-help="Puede usar las flechas del teclado y espacio"
              />
            </div>
            <div class="mt-3">
              <vs-select
                autocomplete
                class="w-100 con-select autocompletex"
                label="Seleccione tipo de Firma"
                v-model="signType"
              >
                <vs-select-item
                  :value="firma"
                  :text="firma.proveedor"
                  v-for="firma in userSignConfiguration.userSigns"
                  :key="firma.id"
                />
              </vs-select>
            </div>
            <div class="mt-3">
              <vs-input
                class="w-100"
                label="Código OTP"
                maxlength="6"
                name="otp"
                v-model="otpCode"
                v-validate="'required'"
                :danger="errors.has('sign-document.otp')"
                :danger-text="errors.first('sign-document.otp')"
              />
            </div>
          </div>
        </form>
        <div class="m-top-20" style="display: flex;justify-content: flex-end;">
          <vs-button color="dark" v-on:click="cancelProcess()" type="border">Cancelar</vs-button>
          <vs-button
            v-if="otpCode !== ''"
            v-on:click="processFile()"
            color="primary"
            style="margin-left: 12px;"
            type="border"
          >
            Tramitar expediente
          </vs-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import pdf from 'vue-pdf-signature';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import DragSignOffice from '@/febos/chile/approvals/components/trays/managementTray/DragSignOffice';
import { ioDownloadPrivateFile } from '@/febos/servicios/api/herramientas.api';

export default {
  data() {
    return {
      comment: '',
      file: {},
      sign: false,
      positionSign: undefined,
      selectedFile: '',
      numPages: undefined,
      otpCode: '',
      signType: '',
      filePdf: {},
      max: this.$moment().format('YYYY-MM-DD'),
      manageDate: this.$moment().subtract(5, 'day').format('YYYY-MM-DD')
    };
  },
  components: { UploadFile, pdf, DragSignOffice },
  props: {
    controlFile: {
      type: [Object],
      required: true,
      default: () => {}
    }
  },
  watch: {
    loading(value) {
      if (!value) {
        this.$vs.loading.close('#management > .con-vs-loading');
        return;
      }

      this.$vs.loading({
        container: '#management',
        scale: 0.6
      });
    },
    fileOnFlowAttachments() {
      this.selectFile(this.fileOnFlowAttachments[0]);
    }
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Empresas', [
      'userSignConfiguration'
    ]),
    ...mapGetters('Approvals', [
      'loading'
    ]),
    showModal: {
      get() {
        return this.modalName === 'controlReceived';
      },
      set() {
        this.closeModal();
      }
    },
    urlFile() {
      return `febos-io/temporal/${process.env.VUE_APP_AMBIENTE}/aprobaciones/${this.controlFile.febosId}/contraloria/`;
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'processDntFileED',
      'downloadPrivateFile'
    ]),
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Approvals', [
      'signAttachmentFlow'
    ]),
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async processFile() {
      const isValid = await this.validateForm('sign-document');
      if (!isValid) {
        return;
      }

      const sign = this.getPosition();

      if (!sign.y || !sign.x) {
        this.$bvToast.toast(
          'No has colocado la ubicación de la estampa',
          {
            title: '¡Oops!',
            variant: 'warning',
            pauseOnHover: true,
            solid: true,
            autoHideDelay: 4000,
          }
        );
        return;
      }

      const body = {
        adjuntoUrlS3: this.filePdf.url,
        febosId: this.controlFile.febosId,
        idExterno: this.controlFile.febosId,
        codigoAutenticador: this.otpCode,
        passwordCertificado: 'na',
        remplazarS3: true,
        tipoFirma: this.signType.tipo,
        tipo: 'firmar_contraloria',
        idFirma: this.signType.id,
        OTP: this.otpCode,
        pagina: sign.page,
        // eslint-disable-next-line radix
        y: parseInt(sign.y),
        x: sign.x
      };

      const response = await this.signAttachmentFlow(body);
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
    },
    setSign() {
      this.sign = true;
      const pageHeight = this.$refs.pdfViewport.scrollHeight / this.numPages;
      const position = pageHeight * this.numPages;
      const pageWidth = this.$refs.pdfViewport.scrollWidth;
      this.positionSign = {
        x: pageWidth - 250,
        y: position > 0 ? position - 70 : pageHeight - 70
      };
      const [signSelected] = this.userSignConfiguration.userSigns;
      const segPresSign = this.userSignConfiguration.userSigns.find((sign) => sign.proveedor.includes('Segpres'));
      if (segPresSign) {
        this.signType = segPresSign;
      } else {
        this.signType = signSelected;
      }
    },
    getPosition() {
      if (this.$refs.sign) {
        const position = this.$refs.sign.getPosition();
        const pageHeight = this.$refs.pdfViewport.scrollHeight / this.numPages;
        const page = Math.ceil(position.absoluteY / pageHeight);

        const x = position.absoluteX;
        const y = position.absoluteY - pageHeight * (page - 1);
        return {
          ...position,
          x,
          y,
          page
        };
      }
      return '';
    },
    async selectFile(url) {
      this.filePdf = {
        url
      };
      this.selectedFile = pdf.createLoadingTask(this.filePdf.url);
      await this.selectedFile.promise.then((pdfUrl) => {
        this.numPages = pdfUrl.numPages;
      });
      await setTimeout(() => {
        this.setSign();
      }, 2000);
    },
    async getFile() {
      const fileProcessed = await ioDownloadPrivateFile(
        { path: this.file.path, nombre: this.file.name, descargable: false }
      );
      await this.selectFile(fileProcessed.data.url);
    },
    async addFile() {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      await this.getFile();

      await this.$validator.reset();
    },
    cancelProcess() {
      this.closeModal();
    }
  },
  created() {
    this.file = {};
    this.selectedFile = {};
    this.filePdf = {};
    this.otpCode = '';
  }
};
</script>
<style>
.fullscreen {
  height: 90vh;
}
.annotationLayer {
  position: absolute !important;
  border-bottom: 1px solid #c3c3c3;
}

.linkAnnotation {
  transform: unset !important;
  transform-origin: unset !important;
  left: unset !important;
  top: unset !important;
  right: 0 !important;
  bottom: 0 !important;
}
.container-pdf {
  max-height: 85vh;
  overflow-y: auto;
}
.page {
  height: auto;
  margin: 0 auto;
}
</style>
